function rowDocHoverBack() {
    const wrapper = document.querySelector('.docs-wrapper');
    if (!wrapper) return;

    const hoverBack = wrapper.querySelector('.hover-back');
    const rows = wrapper.querySelectorAll('.row-doc');
    if (!hoverBack || rows.length === 0) return;

    rows.forEach(row => {
      row.addEventListener('mouseenter', () => {
        const offsetTop = row.offsetTop;
        hoverBack.style.transform = `translateY(${offsetTop}px)`;
      });
    });

    wrapper.addEventListener('mouseleave', () => {
      hoverBack.style.transform = 'translateY(0)';
    });
  }

  export default rowDocHoverBack;
